import Icon from '../components/Icon.vue'

Icon.register({
  bible: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 358.4c0 9.6-3.2 16-9.6 19.2-3.2 12.8-3.2 57.6 0 73.6 6.4 6.4 9.6 12.8 9.6 19.2v16c0 16-12.8 25.6-25.6 25.6h-326.4c-54.4 0-96-41.6-96-96v-320c0-54.4 41.6-96 96-96h326.4c16 0 25.6 9.6 25.6 25.6v332.8zM144 144v32c0 8.8 7.2 16 16 16h48v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-112h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16zM380.8 448v-64h-284.8c-16 0-32 12.8-32 32s12.8 32 32 32h284.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bible.js
// module id = 659
// module chunks = 0